import { useMemo } from 'react';
import { useOpco } from '.';
import { Opco } from '../models';

export function useOpcoUrlPrefix(): string {
	const opco = useOpco();

	const prefix: string = useMemo(() => {
		switch (opco) {
			case Opco.Noordhoff:
				return 'atlas';
			case Opco.Plantyn:
				return 'atlas';
		}
	}, [opco]);

	return prefix;
}
